export default function stripProtocol(url) {
  if (url && url.length) {
    return url.replace(/^https?:/, '');
  } else {
    return url;
  }
}
